import React from "react";
import { Dropdown, Button, Col } from "antd";
import {
  CalendarOutlined,
  DownloadOutlined,
  FileExcelOutlined,
  FileImageOutlined,
} from "@ant-design/icons";
import { handleDownloadChart } from "../../utils/helpers";
import { ColorPalette } from "../../constants";
import { useSelector } from "react-redux";

const ExportDropdown = ({
  chartId,
  handleExcel,
  handleICal,
  menuItems = ["xlsx", "png"],
  label,
  buttonProps = {},
}) => {
    const organization = useSelector(({ auth }) => auth.organization);

  const items = [
    {
      key: "xlsx",
      label: (
        <div
          className="d-flex align-items-center gap-1"
          style={{ color: "green" }}
        >
          <FileExcelOutlined style={{ color: "green" }} />
          خروجی اکسل (XLSX)
        </div>
      ),
    },
    {
      key: "png",
      label: (
        <div
          className="d-flex align-items-center gap-1"
          style={{ color: organization?.color_code }}
        >
          <FileImageOutlined style={{ color: organization?.color_code }} />
          عکس (PNG)
        </div>
      ),
    },
    {
      key: "ical",
      label: (
        <div
          className="d-flex align-items-center gap-1"
          style={{ color: organization?.color_code }}
        >
          <CalendarOutlined style={{ color: organization?.color_code }} />
          تقویم گوگل،... (ICAL)
        </div>
      ),
    },
  ];

  const handleMenuClick = ({ key }) => {
    key == "ical"
      ? handleICal()
      : key == "png"
      ? handleDownloadChart(chartId, key)
      : handleExcel();
  };

  return (
    <Dropdown
      menu={{
        items: items.filter((item) => menuItems.includes(item.key)),
        onClick: handleMenuClick,
      }}
      placement="bottom"
    >
      <Button type="primary" shape="circle" ghost {...buttonProps}>
        <DownloadOutlined />
        {label}
      </Button>
    </Dropdown>
  );
};

export default ExportDropdown;
